import Vue from 'vue'
import lodashMerge from 'lodash.merge'

function successAlert(msg, options = {}) {
  Vue.toasted.success(msg, mergeAlert(options))
}

function errorAlert(msg, options = {}) {
  Vue.toasted.error(msg, mergeAlert(options))
}

function infoAlert(msg, options = {}) {
  Vue.toasted.info(msg, mergeAlert(options))
}

function mergeAlert(options) {
  const defaultObj = {
    duration: 2000,
    action: {
      icon: 'times',
      onClick: (e, toastObject) => {
        toastObject.goAway(0)
      },
    },
  }
  return lodashMerge(defaultObj, options)
}

export { successAlert, errorAlert, infoAlert }
